import React, { memo } from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SuggestionType, SuggestionProps } from '../types';

const SuggestionButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'white',
  border: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.primary,
  textTransform: 'none',
  fontSize: '12px',
  padding: theme.spacing(0.5, 1.5),
  borderRadius: theme.spacing(0.5),
  '&:hover': {
    backgroundColor: '#f9fafb',
  },
}));

export const Suggestion: React.FC<SuggestionProps> = memo(({
  text,
  onClick,
  disabled = false,
}) => {
  const handleClick = () => {
    if (!disabled) {
      onClick(text);
    }
  };

  const displayText = typeof text === 'string' ? text : text.text;

  return (
    <SuggestionButton
      onClick={handleClick}
      disabled={disabled}
    >
      {displayText}
    </SuggestionButton>
  );
});

Suggestion.displayName = 'Suggestion';

